import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { trigger, state, animate, transition, style, keyframes } from '@angular/animations';
import { BaseComponent } from '../base.component';
import { SharedService } from '../shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../loader.service';
import { ValidationService } from '../../technician/technician-jobs/technician-common-validation';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
import {
    EquipmentEntity, WoJobTaskDetails, JobPrintPre,
    JobDetailMaster, JobAppointMent, SpecialService, PrintPreview, Logo, Company, PricingModelTable, PricingModel, PrintEquipmentEntity, PrintJobDetails, PrintPartRequest, PartRequestEntity, PricingModelListEntity
} from '../../technician/technician-jobs/technician-jobs.models';
import { WoSLAHistory, TaxGroup } from '../../work-order/work-order-models';
import { WoService } from 'app/layout/work-order/work-order.service';
declare let jsPDF;
@Component({
    selector: 'wo-job-print-preview-popup',
    templateUrl: 'wo-print-preview.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ],
    styles: [`
    .custom-th-le{
        background: #eeeeee !important;
        padding: 2px 10px !important;
        text-align: right;
        
    }
    .custom-th-ri{
        //padding: 8px 10px !important;
        text-align: right;
        
    }
    .Tbl-Border-print{
     border: 1px solid #C0C0C0;
    }
    .address-head{
        background: #eeeeee !important;
        padding: 3px 5px !important;
    text-align: left;
    
    }
    
    .job-dtl tbody>tr>td {
        padding: 2px;
    }
    .m-dialog { width: 80%;margin: 30px auto;} 
    .hideScreen{display:none;} 
    #PrintPanel table > thead > tr > th, table > tbody > tr > th, table > tfoot > tr > th, table > thead > tr > td, table > tbody > tr > td, table > tfoot > tr > td {border-top: 0; } 
    #PrintPanel { font: 12px calibri;}  
    .s_formLabel {border: 1px solid #ccc;}
    .s_formLabel > tbody > tr{       
        border-bottom: 1px solid #ccc;
        color: #505050;      
    }
    .s_formLabel > tbody > tr > td{
        padding: 5px;
    }
    #printContainer tr th{
        background: #eeeeee !important;
        padding: 8px 0 !important;
        color: #4e4e4e !important;
        text-align: center;
       }
       .Tbl-Border{
        border: 1px solid #bfbfbf;
    }
    .main-heading h1{font-size:15px !important;color:#4e4e4e!important;}
    .SignatureTbl
    {
     border-top: 1px solid #ccc;
     padding: 5px 20px 0 20px;
     color: #4e4e4e;
     font-size: 13px;
    }
    .Tbl-Span
   {
    font-size: 12px;
    color: #484848;
   }
    `],
    encapsulation: ViewEncapsulation.None
})

export class WoJobPrintPreviewComponent extends BaseComponent implements OnInit {
    isEnableTax: boolean = false;
    @Output() done = new EventEmitter();
    @Input() woJobId: number;
    @Input() CustomerId: number;
    @Input() TechId: number;
    @Input() WorkOrderId: number;
    @Input() woJobIdList: number[] = [];
    companyId: number;
    userId: number;
    equipmentEntity: EquipmentEntity[] = [];
    jobId: number;
    jobDetailMaster: JobDetailMaster;
    jobAppointMent: JobAppointMent;
    logo: Logo = new Logo();
    customerAndTechDetails: PrintPreview;
    JobPrintpreview: JobPrintPre[];
    customerAndTechDetailsList: PrintPreview[];
    jobDetailListTab: WoJobTaskDetails[] = [];
    specialInstruction: SpecialService[] = [];
    serviceNotes: SpecialService[] = [];
    technicianRemarksList: SpecialService[] = [];
    serviceNotesReason: any;
    specialInsstructionReason: any;
    displayName: string;
    company: Company = new Company();
    companyAddress: string;
    logoPrintout: Logo = new Logo();
    logoPrintoutHeader: Logo = new Logo();
    logoPrintoutFooter: Logo = new Logo();
    WoJobNo: string = "";
    partRequestEntity: PartRequestEntity[] = [];
    hoursStr: string;
    minStr: string;
    daysStr: string;
    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;
    isVisible: boolean = false;

    printEquipEntity: PrintEquipmentEntity[] = [];
    EquipmentEntitylist: EquipmentEntity[] = [];
    EquipmentEntitylistEntity: EquipmentEntity[] = [];
    isEquipment: boolean = false;

    printJobDetails: PrintJobDetails[] = [];
    jobDetail: WoJobTaskDetails[] = [];
    jobDetailEntity: WoJobTaskDetails[] = [];
    isjobDetail: boolean = false;

    printPartRequest: PrintPartRequest[] = [];
    partRequest: PartRequestEntity[] = [];
    partRequestListEntity: PartRequestEntity[] = [];
    isPartRequest: boolean = false;

    constructor(protected sharedService: SharedService, protected translate: TranslateService, protected _woService: WoService,
        private _technicianJobService: TechnicianJobService, private datePipe: DatePipe, private loaderService: LoaderService) {
        super(sharedService, translate);

        this.companyId = super.globalInfo().CompanyId;
        this.userId = super.globalInfo().LoginId;
        this.customerAndTechDetails = new PrintPreview();
        this.customerAndTechDetailsList = [];
        this.woslahistory = new WoSLAHistory();
        this.currency = super.globalInfo().Currency;
    }

    ngOnInit() {
        let jobIds = this.woJobIdList;
        if (this.woJobIdList.length == 0) {
            this.woJobIdList.push(this.woJobId);
            jobIds = this.woJobIdList;
        }
        this.getJobDetailsPrintPre(jobIds);
        this.getPricingDetails(jobIds);
        this.printlogo(jobIds[0]);
    }

    getJobDetailsPrintPre(wojob: number[]) {
        debugger;
        this.loaderService.show();
        this._technicianJobService.getWorkorderJobDetailsPrint(this.companyId, wojob, this.WorkOrderId, this.TechId)
            .subscribe(s => {
                this.JobPrintpreview = s;
                this.loaderService.hide();
                this.JobPrintpreview.forEach(model => {
                    let f = model.CustomerTechDetail;
                    if (f != null) {
                        model.CustomerTechDetail = f;
                        model.CustomerTechDetail.TotalJobDuration = ValidationService.fullDayhourFormat(f.Days, f.Hours, f.Minutes);
                        model.CustomerTechDetail.TechDisplayName = f.TechDisplayName;
                        this.WoJobNo = f.WoJobId + "(" + f.WoNumber + ")";
                        model.CustomerTechDetail.WoJobId = model.JobDetail[0].WoJobId;
                        model.CustomerTechDetail.CreatedDate = this.datetimeFormat(f.CreatedDate);
                        model.CustomerTechDetail.ScheduleDate = this.datetimeFormat(f.ScheduleDate);
                        model.CustomerTechDetail.UnitNo = model.CustomerTechDetail.UnitNo == null ? '' :model.CustomerTechDetail.UnitNo;
                        
                        this.GetSpeciInstrAndServiNote(f.TimeZoneId, wojob[0]);                        
                    }

                    model.JobDetail = model.JobDetail.map(m => {
                        debugger;
                        m.HourAndMinutes = ((m.Hours !== null && +m.Hours !== 0) ? m.Hours + ' hr ' : '') + ((m.Minutes !== null && +m.Minutes !== 0) ? m.Minutes + ' mins' : '');
                        m.CompanyId = this.companyId;
                        if (m.ScheduleDate != null && m.ScheduleDate != "") {
                            var sDate = this.removeTime(m.ScheduleDate);
                            if (new Date(m.ScheduleStartDateTime.split(' ')[0]).getDate() == new Date(m.ScheduleEndDateTime.split(' ')[0]).getDate()) {
                                //   m.ScheduleDate = this.datePipe.transform(m.ScheduleStartDateTime, 'shortDate') + ' - ' + this.datePipe.transform(m.ScheduleEndDateTime, 'shortDate');
                                m.ScheduleDate = this.datePipe.transform(sDate, 'dd/MM/yyyy') + " " + this.datePipe.transform(m.ScheduleStartDateTime, 'shortTime') + " to " + this.datePipe.transform(m.ScheduleEndDateTime, 'shortTime');
        
                            }
                            else
                                m.ScheduleDate = this.datePipe.transform(m.ScheduleStartDateTime, 'dd/MM/yyyy') + " " + this.datePipe.transform(m.ScheduleStartDateTime, 'shortTime') + " to " + this.datePipe.transform(m.ScheduleEndDateTime, 'dd/MM/yyyy') + " " + this.datePipe.transform(m.ScheduleEndDateTime, 'shortTime');
                        }
                        return m;
                    });

                    wojob.forEach(wj => {
                        //group equipment's job id
                        this.EquipmentEntitylist = [];
                        this.EquipmentEntitylistEntity = [];
                        model.Equipment.forEach(fa => {
                            if (wj == fa.WoJobId) {
                                this.EquipmentEntitylist.push(fa);
                                this.EquipmentEntitylistEntity = this.EquipmentEntitylist;
                                this.isEquipment = true;
                            }
                        });
                        // if (this.isEquipment) {
                        //     this.printEquipEntity.push({ WoJobId: wj, EquipmentEntitylist: this.EquipmentEntitylistEntity });
                        // }
                        this.isEquipment = false;

                        //group job detail's job id
                        this.jobDetail = [];
                        this.jobDetailEntity = [];
                        model.JobDetail.forEach(jd => {
                            if (wj == jd.WoJobId) {
                                if (jd.VendorName != null && jd.VendorName != "" && jd.Technician != null && jd.Technician != "") {
                                    jd.VendorTechnician = jd.VendorName + ' / ' + jd.Technician;
                                }
                                else if (jd.VendorName != null && jd.VendorName != "" && (jd.Technician == null || jd.Technician == "")) {
                                    jd.VendorTechnician = jd.VendorName;
                                }
                                else if ((jd.VendorName != null || jd.VendorName != "") && jd.Technician != null && jd.Technician != "") {
                                    jd.VendorTechnician = jd.Technician;
                                }
                                this.jobDetail.push(jd);
                                this.jobDetailEntity = this.jobDetail;
                                this.isjobDetail = true;
                            }
                        });
                        if (this.isjobDetail) {
                            this.printJobDetails.push({ WoJobId: wj, JobDetail: this.jobDetailEntity, VendorTechnician: this.jobDetailEntity[0].VendorTechnician });
                        }
                        this.isjobDetail = false;

                        //group part request job detail's  job id
                        this.partRequest = [];
                        this.partRequestListEntity = [];
                        model.PartRequest.PartLists.forEach(pl => {
                            if (wj == pl.WoJobId) {
                                this.partRequest.push(pl);
                                this.partRequestListEntity = this.partRequest;
                                this.isPartRequest = true;
                            }
                        });
                        if (this.isPartRequest) {
                            this.printPartRequest.push({ WoJobId: wj, PartRequest: this.partRequestListEntity });
                        }
                        this.isPartRequest = false;
                    });


                });

            }, e => { this.loaderService.hide(); });
    }
    removeTime(time: string): string {
        if (time != null) {
            return time.split(' ')[0];
        }
        return "";
    }
    durationCalc(val: number) {
        if (val <= 0)
            return "";
        var comStr = "";
        var hrs = 0;
        var days = 0;
        var i = 0, j = 0;
        if (val < 60) {
            comStr = 0 + " " + this.hoursStr + " " + val + " " + this.minStr;
            return comStr;
        }

        for (i = 60; i <= val;) {
            hrs = hrs + 1;
            i = i + 60;
        }
        i = i - 60;
        if (hrs >= 24) {
            for (j = 24; j <= hrs;) {
                days = days + 1;
                j = j + 24;
            }
            j = j - 24;
            comStr = days + " " + this.daysStr + " " + (hrs - j) + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        }
        else
            comStr = hrs + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        return comStr;
    }

    GetSpeciInstrAndServiNote(TechTimeZoneid: number, wojob: number): void {
        this.specialInstruction = [];
        this.serviceNotes = [];
        this.technicianRemarksList = [];
        this.loaderService.show();//this.woJobId
        this._technicianJobService.GetSpeciInstrAndServiNote(this.companyId, wojob, this.userId, TechTimeZoneid, this.CustomerId, this.WorkOrderId)
            .subscribe(s => {
                this.loaderService.hide();
                this.displayName = s.DisplayName;
                this.specialInstruction = s.GetWojobSplInsDetails;
                this.serviceNotes = s.GetWojobServiceNotesDetails;
                this.technicianRemarksList = s.GetWojobTechnicialRemark;
                this.specialInstruction.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.serviceNotes.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.technicianRemarksList.map(x => {
                    x.CreateAndUpdateDate = x.CreatedDate ? this.datetimeFormat(x.CreatedDate) : null;
                    x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />');
                });

                if (this.serviceNotes.length != 0)
                    this.serviceNotesReason = this.serviceNotes[this.serviceNotes.length - 1].Note;
                if (this.specialInstruction.length != 0)
                    this.specialInsstructionReason = this.specialInstruction[this.specialInstruction.length - 1].Note;

            });
    }

    datetimeFormat(dateTimeVal: any): any {
        if (dateTimeVal == "0001-01-01T00:00:00" || dateTimeVal == "" || dateTimeVal == null || dateTimeVal == "1/1/0001 12:00:00 AM")
            return "";
        else
            return this.datePipe.transform(dateTimeVal, 'shortDate')
    }

    closePopup() {
        this.done.emit();
    }

    printlogo(wojob: number) {
        this._technicianJobService.getCompany(this.companyId).subscribe(cus => {
            this.company = cus;
            this.companyAddress = (this.company.AddressLine1 + ' ' + this.company.AddressLine2 + ' ' + this.company.CityName + ' ' + this.company.StateName +' '+this.company.ZipCode+' '+this.company.CountryName);
            if (this.company.PrintoutLogoPath != "" || this.company.PrintoutLogoPath != null || this.company.PrintoutLogoPath != null) {
                this._technicianJobService.GetPrintoutLogo(this.companyId, this.company.PrintoutLogoPath).subscribe(res => {
                    this.logoPrintout = res;
                });
            }

            if (this.company.PrintoutHeaderPath != "" || this.company.PrintoutHeaderPath != null || this.company.PrintoutHeaderPath != null) {
                this._technicianJobService.GetPrintoutHeader(this.companyId, this.company.PrintoutHeaderPath).subscribe(res => {
                    this.logoPrintoutHeader = res;
                });
            }

            if (this.company.PrintOutFooterPath != "" || this.company.PrintOutFooterPath != null || this.company.PrintOutFooterPath != null) {
                this._technicianJobService.GetPrintoutFooter(this.companyId, this.company.PrintOutFooterPath).subscribe(res => {
                    this.logoPrintoutFooter = res;
                });
            }
        });
    }

    Print(): void {
        let popupWinindow: any;
        let innerContents: any = document.getElementById('printArea').innerHTML;
        let themeClass = document.body.getAttribute("class");
        popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        var headerScript = ` 
             <style>
             @media print {    
                .custom-th-le{
                    background: #eeeeee !important;
                    padding: 2px 10px !important;
                    text-align: right;
                    
                }  
                .custom-th-ri{
                    text-align: right;
                }
                .address-head{
                    background: #eeeeee !important;
                    padding: 3px 5px !important;                
                text-align: left;
                }  
                    
                .sn_pricing_table .printtotal{
                    border-bottom: 1px solid rgba(0,0,0,0.1)!important;    
                    height: 35px;
                }
                #printContainer tr th{
                    background: #D9D9D9 !important;
                    padding: 8px 0 !important;
                    text-align: center;
                   }
                .job-dtl tbody>tr>td {
                    padding: 2px;
                    border-collapse: collapse !important;
                }
                .main-heading h1{font-size:16px !important;font-weight: 600;color:black!important;
                    line-height: normal;}
                }
                .Tbl-Border  tbody > tr > td{padding: 3px !important;}
                .Tbl-Border{
                    border: 1px solid #bfbfbf;
                }
                .s_formLabel > tbody > tr > td{
                    padding: 5px;
                }
                #PrintPanel table > thead > tr > th, table > tbody > tr > th, table > tfoot > tr > th, table > thead > tr > td, table > tbody > tr > td, table > tfoot > tr > td {border-top: 0; color:black!important;padding:5px!important } 
                #PrintPanel { font: 12px calibri;}  
                #PrintPanel  thead > tr > th{ font-weight: 600;line-height: normal; }

      </style>`;
        // setTimeout(window.close, 5);
        popupWinindow.document.write('<html><head><title>'+this.JobPrintpreview[0].CustomerTechDetail.WoNumber +'</title>	<link rel="stylesheet" href="/assets/css/zylog-skin.css"><link rel="stylesheet" href="/assets/css/zylog-print.css">' + headerScript + '</head><body id="wrapper" class="' + themeClass + '" onload="window.print();setTimeout(window.close, 5);">' + innerContents + '</body></html>');
        popupWinindow.document.close();
    }
    //pricingModel: PricingModel[] = [];
    pricingModelTable: PricingModelTable[] = [];
    pricingModel: PricingModelTable[] = [];
    pricingModelTableList: PricingModelTable[] = [];
    pricingModelListEntity: PricingModelListEntity[] = [];
    isPricingModel: boolean = false;
    TaskNoLst: number[];
    jobTaskDetailsList: WoJobTaskDetails[] = [];
    JobIdLst: number[];
    getPricingDetails(wojob: number[]) {
        this._woService.getWoPricing(this.globalInfo().CompanyId, this.WorkOrderId) //this.woId
            .subscribe(s => {
                this.isEnableTax = this.sharedService.isEnableTax;
                //
                let r = s.WoPriceDetailList.map(m => {
                    m.IsEdit = super.globalInfo().MaxRoleGroup == 2 ? false : (super.globalInfo().MaxRoleGroup == 3) ?
                        (super.globalInfo().VendorId != s.WoJobDetails.filter(x => x.WoJobId == m.WoJobId)[0].VendorId) :
                        (super.globalInfo().MaxRoleGroup == 5 || super.globalInfo().MaxRoleGroup == 6) ?
                            (super.globalInfo().DisplayName != s.WoJobDetails.filter(x => x.WoJobId == m.WoJobId)[0].DisplayName) : false;
                    return m;
                })

                this.pricingModelTable = r;
                this.pricingModelTable.map(m=>{
                    m.Qty = m.PricingUnitId == 418  && m.PriceTypeId == 83? this.hourCalculation(m.DaysPerTask, m.HoursPerTask, m.MinutesPerTask).toString() : m.Qty;
                });
                if (super.globalInfo().MaxRoleGroup == 3) {
                    let j = s.WoJobDetails.filter(x => x.VendorId == super.globalInfo().VendorId);
                    this.JobIdLst = j.map(m => {
                        return m.WoJobId
                    });
                }
                else if (super.globalInfo().MaxRoleGroup == 5 || super.globalInfo().MaxRoleGroup == 6) {
                    let j = s.WoJobDetails.filter(x => x.DisplayName == super.globalInfo().DisplayName);
                    this.JobIdLst = j.map(m => {
                        return m.WoJobId
                    });
                }
                else
                    this.JobIdLst = s.JobIdList;

                this.TaskNoLst = s.TasknoList;
                this.jobTaskDetailsList = s.WoJobDetails;

                this.pricingTableFillingdummmy(this.pricingModelTable, wojob);


            });
    }
    isTotalWorkOrder: boolean = false;
    totalWorkOrderPrice: any;
    priceJob: PricingModelTable[] = [];
    priceJobs: PricingModelTable;
    tax: TaxGroup[] = [];
    taxGroup: TaxGroup[] = [];
    jobTotal: any = 0;
    currency: any;
    totalDiscount: any = 0;
    grandTotal: any = 0;
    taxTotal: any = 0;

    pricingTableFillingdummmy(pricingAll: PricingModelTable[], wojob: number[]) {
        debugger;
        this.isTotalWorkOrder = false;
        // this.jobGrandTotal = 0
        this.totalWorkOrderPrice = 0;
        this.isEnableTax = this.sharedService.isEnableTax;
        this.priceJob = [];
        this.priceJobs = new PricingModel();

        this._technicianJobService.getTaxGroup(super.globalInfo().CompanyId, 1).subscribe(res => {
            this.tax = res.filter(t => t.IsActive == 1);

            this._technicianJobService.getTaxGroup(super.globalInfo().CompanyId, 2).subscribe(res1 => {
                this.taxGroup = res1.filter(t => t.IsActive == 1);

                pricingAll.forEach(y => {
                    if (this.priceJob.length == 0) {
                        this.priceJobs = y;
                        this.priceJob.push(this.priceJobs);
                    }
                    else {
                        if (this.priceJobs.WoJobId != y.WoJobId) {
                            this.priceJobs = y;
                            this.priceJob.push(this.priceJobs);
                        }
                    }

                }
                );
                this.priceJob.forEach(y => {
                    this.jobTotal = 0;
                    pricingAll.forEach(m => {
                        debugger;
                        if (m.WoJobId == y.WoJobId) {
                            if (m.IsBOQRequest == 1 && m.ApprovalStatusId == 3)
                                m.TotalAmount = ((m.ApprovedQty == null ? 0 : m.ApprovedQty) * (m.UnitPrice == null ? 0 : m.UnitPrice));
                            else
                                m.TotalAmount = ((m.Qty == null ? 0 : m.Qty) * (m.UnitPrice == null ? 0 : m.UnitPrice));

                            let discount = (m.Discount == 0 || m.Discount == null ? 0 : m.Discount);
                            let totamount = (m.TotalAmount == 0 || m.TotalAmount == null ? 0 : m.TotalAmount);
                            m.NetTotalFormat = ((totamount) == 0 ? '0' : (totamount));

                            // /**Flat calculations */
                            // if (m.DiscountTypeId == 80) {
                            //     m.NetTotalFormat = ((totamount - discount) == 0 ? '0' : (totamount - discount));
                            // }
                            // /**Discount calculations */
                            // if (m.DiscountTypeId == 81) {
                            //     let nettotal = (totamount - ((totamount * discount) / 100));
                            //     m.NetTotalFormat = nettotal == 0 ? '0' : nettotal;
                            // }

                            m.TaxFormat = m.Percentage == null ? '0' : (m.NetTotalFormat * m.Percentage / 100);
                            //m.NetTotalFormat = (ValidationService.isEmpty(m.NetTotalFormat + m.TaxFormat)) ? "0" : (m.NetTotalFormat + m.TaxFormat);
                            m.NetTotalFormat = (ValidationService.isEmpty(m.NetTotalFormat)) ? "0" : (m.NetTotalFormat);
                            m.TaxFormat = (m.TaxFormat == null || (ValidationService.isEmpty(m.TaxFormat)) ? 0 : (m.TaxFormat));
                            this.jobTotal += (ValidationService.isEmpty(m.NetTotalFormat) ? 0 : (+m.NetTotalFormat));
                            m.NetTotalFormat = ((ValidationService.isEmpty(m.NetTotalFormat)) ? "-" : (this.currency + parseFloat(m.NetTotalFormat).toFixed(2)));

                            if (m.IsBOQRequest == 1)
                                m.QtyFormat = (m.ApprovalStatusId == 3 ? ((m.ApprovedQty == 0 || m.ApprovedQty == null) ? '-' : m.ApprovedQty) : ((m.Qty == 0 || m.Qty == null) ? '-' : m.Qty));
                            else
                                m.QtyFormat = ((m.Qty == 0 || m.Qty == null) ? '-' : m.Qty);

                            m.UnitPriceFormat = ((m.UnitPrice == 0 || m.UnitPrice == null) ? '-' : this.currency + parseFloat(m.UnitPrice).toFixed(2));
                            m.TotalAmountFormat = ((m.TotalAmount == 0) ? '-' : this.currency + parseFloat(m.TotalAmount).toFixed(2));

                            m.DiscountFormat = (ValidationService.isEmpty(m.Discount)

                                ? '-' : (m.DiscountTypeId == 80 ? (this.currency + m.Discount) : m.Discount + '%'));

                            //print
                            if (m.DiscountTypeId == 80) {
                                m.PDiscountAmt = (+m.Discount).toFixed(2);
                            }
                            if (m.DiscountTypeId == 81) {
                                let discoumtAmount = (((totamount) * (+m.Discount)) / 100);
                                m.PDiscountAmt = (+discoumtAmount);
                            }
                            m.PDiscountAmt = parseFloat((m.PDiscountAmt == null || m.PDiscountAmt == '' ? "0" : m.PDiscountAmt));

                            let TaxAmt = ((totamount) * +m.Percentage / 100);
                            m.PTaxAmt = (+TaxAmt).toFixed(2);
                            m.PTaxAmt = parseFloat((m.PTaxAmt == null || m.PTaxAmt == '' ? "0" : m.PTaxAmt));
                            this.totalDiscount += m.PDiscountAmt;
                            this.taxTotal += m.TaxFormat;
                            console.log("taxamt " + m.PTaxAmt + ", dicount " + m.PDiscountAmt);
                        }

                    });
                    this.pricingModelTable.filter(s => s.WoJobId == y.WoJobId).map(v => v.JobTotal = this.jobTotal.toFixed(2));
                    

                    if (!this.isTotalWorkOrder)
                        this.totalWorkOrderPrice = (ValidationService.isEmpty(this.totalWorkOrderPrice + this.jobTotal)) ? "0.00" : (this.totalWorkOrderPrice + this.jobTotal);

                });
                debugger;               
                
                if (!this.isTotalWorkOrder) {
                    this.totalWorkOrderPrice = parseFloat(this.totalWorkOrderPrice).toFixed(2);
                    this.isTotalWorkOrder = true;
                }

                if(this.isEnableTax)
                this.grandTotal = this.totalWorkOrderPrice - (+this.totalDiscount) + (+this.taxTotal);
                else{
                this.grandTotal = this.totalWorkOrderPrice -(+this.totalDiscount);
                this.grandTotal = parseFloat(this.grandTotal).toFixed(2);
            }

                wojob.forEach(wj => {
                    debugger;
                    //group pricing job id
                    this.pricingModel = [];
                    this.pricingModelTableList = [];
                    this.pricingModelTable.forEach(fa => {
                        if (wj == fa.WoJobId) {
                            this.pricingModel.push(fa);
                            this.pricingModelTableList = this.pricingModel;
                            this.isPricingModel = true;
                        }
                    });
                    if (this.isPricingModel) {
                        this.pricingModelListEntity.push({ WoJobId: wj, PricingModelTable: this.pricingModelTableList, NetTotalPrint: this.pricingModelTableList[0].JobTotal });
                    }
                    this.isPricingModel = false;
                });

            });
        });


    }
    hourCalculation(DurationDay, DurationHour, DurationMin) {
        var totalhr = 0;
        if (DurationDay > 0)
            totalhr = +DurationDay * 8;
        totalhr += +DurationHour;
        if (DurationMin == 15)
            totalhr += 0.25;
        else if (DurationMin == 30)
            totalhr += 0.50;
        else if (DurationMin == 45)
            totalhr += 0.75;
        return totalhr;
    }
}